import AuthService from '@/packages/auth-service'
import store from '@/app/store'
import CONFIG from '@/app/config/config'
import { getPaginatePaymentLinkMock } from '@/shared/mocks/payment-links'
import { getMockedResponse } from '@/shared/lib/getMockedResponse'
import b2bApiClient from '@/shared/api/b2b-client'

export class PaymentLinkApiService {
  constructor() {
    this.client = b2bApiClient.getClient()
    this.isMock = CONFIG.USE_MOCKS === 'true'
  }

  get _accessToken() {
    return store.state.auth.access_token || AuthService.getAccessToken()
  }

  get _headers() {
    return {
      'Content-Type': 'application/json',
      'x-access-token': this._accessToken,
    }
  }

  async createPaymentLink(formData) {
    try {
      return await this.client.post('/processing/invoice_form', formData, {
        headers: this._headers,
      })
    } catch (error) {
      console.error('Error creating swap app:', error)
      throw error
    }
  }

  async updatePaymentLink(id, formData) {
    return await this.client.put(`/processing/invoice_form/${id}`, formData, {
      headers: this._headers,
    })
  }

  async updatePaymentLinkStatus(id, formData) {
    return await this.client.put(
      `/processing/invoice_form/${id}/status`,
      formData,
      {
        headers: this._headers,
      }
    )
  }

  async getPaginatePaymentLink(params) {
    if (this.isMock) {
      return getMockedResponse(getPaginatePaymentLinkMock)
    }

    return await this.client.get(
      `/processing/partner/invoice_forms`,
      params,
      this._headers
    )
  }

  async getPaymentLinkById(id, params = {}) {
    return await this.client.get(
      `/processing/invoice_form/${id}/partner`,
      params,
      this._headers
    )
  }

  async uploadAvatar(id, file) {
    const formData = new FormData()
    formData.append('file', file)

    return await this.client.post(
      `/processing/invoice_form/${id}/avatar`,
      formData,
      {
        headers: {
          'x-access-token': this._accessToken,
        },
      }
    )
  }

  async deleteAvatar(id) {
    return await this.client.delete(`/processing/invoice_form/${id}/avatar`, {
      headers: this._headers,
    })
  }

  async deletePaymentLink(id) {
    return await this.client.delete(`/processing/invoice_form/${id}`, {
      headers: this._headers,
    })
  }

  async getExcelReport(params) {
    return await this.client.client.get(
      '/processing/partner/invoices/excel-report',
      {
        params,
        paramsSerializer: (params) => {
          const searchParams = new URLSearchParams()
          Object.entries(params).forEach(([key, value]) => {
            if (Array.isArray(value)) {
              if (value.length > 0) {
                value.forEach((item) => {
                  searchParams.append(key, item)
                })
              } else {
                searchParams.append(key, '')
              }
            } else {
              searchParams.append(key, value)
            }
          })
          return searchParams.toString()
        },
        headers: this._headers,
        responseType: 'blob',
      }
    )
  }
}

export const paymentLinkApiService = new PaymentLinkApiService()
export default paymentLinkApiService
